import React, { useState, useEffect } from "react";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import ScoreCardList from "../ScoreCardList/ScoreCardList";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import {
	getSession,
	getCeStatCat,
	getUserRBAC,
} from "../../services/LocalStorageService";
import { ceStats } from "../../services/ContentEngagement";
import { APIURL, EntityAccess, RBAC_CODE, TableComponentCodes } from "../../config/app-globals.enum";
import PraisoTableWrapper from "../../components/CustomComponents/PraisoTable/PraisoTableWrapper";
import ShowMoreOrLess from "../CustomComponents/PraisoTable/ShowMoreOrLess";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function ContentEngagement(props) {
	const params = useParams();
	const { t } = useTranslation();
	const [getRBAC_CE] = React.useState(getUserRBAC(RBAC_CODE.CE_VIEW, props));
	const [getRBAC_CE_Show_Limited] = React.useState(
		getUserRBAC(RBAC_CODE.CE_SHOW_LIMITED_USER_BUTTON_VIEW, props)
	);
	const [ceDataExists, setCeDataExists] = useState(false);
	const [userSession] = useState(getSession());
	const [selectedStatId, setSelectedStatId] = useState(0);
	const [isApiFailed, setIsApiFailed] = React.useState(false);
	const [isApi1Failed, setIsApi1Failed] = React.useState(false);
	const [isApi, setIsApi] = React.useState(false);
	//====
	const [statusValue, setStatusValue] = React.useState();
	const [alertMessage, setAlertMessage] = React.useState("");
	const [isAlertOpen, setIsAlertOpen] = React.useState(false);
	const [showLimitedDriver, setShowLimitedDriver] = useState(null);
	const [apiFilterParams, setApiFilterParams] = useState();

	const changeApiStatusCodeFunc = (status) => {
		if (status.code && status.code !== 0 && status.code !== 200) {
			setStatusValue(status.code);
			setAlertMessage(
				status.message
					? status.message
					: `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
			);
			setIsAlertOpen(true);
		}
	};

	useEffect(() => {
		setShowLimitedDriver(
			getRBAC_CE_Show_Limited &&
				getRBAC_CE_Show_Limited.isAccessible === EntityAccess.ALLOWED
				? 1
				: 0
		);
	}, [getRBAC_CE_Show_Limited]);
	//====
	const [ceStatCat] = React.useState(getCeStatCat);
	const [ceStatsData, setCeStatsData] = React.useState(null);

	useEffect(() => {
		async function getCeStats() {
			setStatusValue(null);
			setAlertMessage("");
			setIsAlertOpen(false);
			const data = await ceStats(params);
			if (
				data &&
				(data.status.code === 0 ||
					data.status.code === 200 ||
					data.status.code === 201) &&
				data.content
			) {
				if (data.content.length > 0) {
					const ceStatDataArray = [];
					for (const stat of ceStatCat) {
						let statData = data.content.find((item) => item.statId === stat.id);
						if (statData) {
							statData = {
								...statData,
								value: statData.statsCount,
								statCode: stat.code,
								label: stat.name,
								color: stat.color,
								dataLoaded: true,
							};
							ceStatDataArray.push(statData);
						}
					}
					setCeStatsData(ceStatDataArray);
				}
			} else {
				setIsApiFailed(true);
				changeApiStatusCodeFunc(data.status);
			}
		}
		getCeStats();
	}, [ceStatCat]);

	//====
	const [ceTableData, setCeTableData] = React.useState();

	useEffect(() => {
		// if (apiFilterParams) {
		//   const getCeList = async (apiFilterParams) => {
		//     setStatusValue(null);
		//     setAlertMessage("");
		//     setIsAlertOpen(false);
		//     setIsApi(true);
		//     const data = await ceList(apiFilterParams);
		//     if (
		//       data &&
		//       (data.status.code === 0 ||
		//         data.status.code === 200 ||
		//         data.status.code === 201) &&
		//       data.content
		//     ) {
		//       setIsApi1Failed(false);
		//       setCeDataExists(true);
		//       setCeTableData(data.content);
		//       setIsApi(false);
		//     } else {
		//       setIsApi(false);
		//       setIsApi1Failed(true);
		//       changeApiStatusCodeFunc(data.status);
		//     }
		//   };
		//   getCeList(apiFilterParams);
		// }
	}, [apiFilterParams]);

	//====
	// useEffect(() => {
	//   if (ceStatsData) {
	//     const filterParams = {
	//       statId: selectedStatId,
	//       pageLength: userSession.pageLength,
	//       pageNo: 1,
	//     };
	//     if (showLimitedDriver === 0) {
	//       filterParams["isShowAllDrivers"] = 1;
	//     } else {
	//       filterParams["isShowAllDrivers"] = 0;
	//     }
	//     // getCeList(filterParams);
	//     setApiFilterParams({ ...filterParams });
	//   }
	// }, [ceStatsData, selectedStatId]);

	//====

	const handleTileClickFunc = (data) => {
		if (data.typeOfScore === "contentengagement") {
			setCeTableData(null);
			setSelectedStatId(data.selectedStatId);
			setShowLimitedDriver(0);
		}
	};

	// const showLimitedDriverFunc = (showLimitedDriverBool) => {
	//   return false;
	//   if (ceStatsData) {
	//     const filterParams = {
	//       pageLength: userSession.pageLength,
	//       pageNo: 1,
	//     };
	//     if (showLimitedDriverBool === 0) {
	//       filterParams["isShowAllDrivers"] = 1;
	//       filterParams["statId"] = selectedStatId;
	//     } else {
	//       filterParams["statId"] = 0;
	//     }
	//     setShowLimitedDriver(showLimitedDriverBool);
	//     // @todo: need to remove
	//     // setApiFilterParams({...filterParams})
	//     // getCeList(filterParams);
	//   }
	// };		

	return (
		<>
			<CustomBox key="contentengagementcontainer" mb={8}>
				<ScoreCardList
					isApiFailed={isApiFailed}
					key="contentengagement"
					data={ceStatsData}
					typeOfScore="contentengagement"
					handleTileClick={handleTileClickFunc}
					selectedStatId={selectedStatId}
					showLimitedDriver={showLimitedDriver}
					isGroupScoped={
						getRBAC_CE_Show_Limited &&
							getRBAC_CE.isAccessible === EntityAccess.ALLOWED
							? false
							: true
					}
				/>
			</CustomBox>
			<div style={{ overflow: "auto" }}>
				<PraisoTableWrapper
					statData={ceStatsData}
					// getTableSettingAPI="/tableSettingApi"
					// getTableSettingAPI="user-table-component-mapping?tcId=7"
					// tableSettingView="ce"
					getTableSettingAPI={`user-table-component-mapping/v1/fetchAll?tcCode=${TableComponentCodes.CONTENT_ENGAGEMENT}`}
					tableSettingView={TableComponentCodes.CONTENT_ENGAGEMENT}
					getTableDataAPI={`${APIURL.CONTENT_USER_LIST_API}${showLimitedDriver === 1 ? 0 : selectedStatId}`}
					getTableDataApiParam={{
						isShowAllDrivers: showLimitedDriver === 1 ? 0 : 1,
					}}
					tableAccordion={{
						component: "ContentEngagementTab",
						componentProps: { userId: "userId", isExpanded: true },
						access: {
							viewEntity: RBAC_CODE.CE_ACCORDION_VIEW,
							accessUserId: "userId",
						},
					}}
					updateCurrentLimitedRow={showLimitedDriver}
					showMoreOrLessComp={
						getRBAC_CE_Show_Limited &&
							getRBAC_CE_Show_Limited.isAccessible === EntityAccess.ALLOWED ? (
							<ShowMoreOrLess
								updateShowMoreStatus={(currentLabel) =>
									setShowLimitedDriver(currentLabel)
								}
								setShowMoreStatus={showLimitedDriver}
							/>
						) : null
					}
					{...props}
				/>
			</div>
			{/* <ContentEngagementRanking
				isApiFailed={isApi1Failed}
				data={ceTableData}
				selectedStatId={selectedStatId}
				ceDataExists={ceDataExists}
				isApi={isApi}
				showLimitedDriver={showLimitedDriver}
				showLimitedDriverSet={(showLimitedDriverBool) =>
					showLimitedDriverFunc(showLimitedDriverBool)
				}
			/> */}
			<ErrorAlert
				code={statusValue}
				message={alertMessage}
				isOpen={isAlertOpen}
				isClose={(isClose) => setIsAlertOpen(!isClose)}
			/>
		</>
	);
}


